<template>
  <div>
    <button
      v-b-tooltip.hover
      v-b-modal="helpId"
      type="button"
      placement="bottom"
      title="Info"
      class="btn mr-4 InformationButton"
    >
      <i class="fas fa-info-circle" />
    </button>
    <b-modal
      :id="helpId"
      :ref="helpId"
      hide-footer
      scrollable
      :title="helpTitle"
      no-fade
    >
      <div class="d-block mb-4">
        <slot />
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    helpId: {
      type: String,
      required: true,
    },
    helpTitle: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.InformationButton {
  background-color: transparent;
  color: #326fff;
  border: none;
  font-size: 25px;
  padding: 0px;
  height: 25px;
}

.InformationButton:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
